export const manifest = {
  screens: {
    scr_gagljj: { name: "Landing / Register", route: "/", state: {"currentScreen":"landing"}, position: {"x":160,"y":1820} },
    scr_hwd6an: { name: "Feed", route: "/", state: {"currentScreen":"feed"}, position: {"x":160,"y":3800} },
    scr_vduojr: { name: "Events", route: "/", state: {"currentScreen":"events"}, position: {"x":1560,"y":3800} },
    scr_bkyfjr: { name: "Go Fish", route: "/", state: {"currentScreen":"go-fish"}, position: {"x":160,"y":5780} },
    scr_lic64i: { name: "My Catches", route: "/", state: {"currentScreen":"catches"}, position: {"x":1560,"y":5780} },
    scr_18pe2e: { name: "Friends", route: "/", state: {"currentScreen":"friends"}, position: {"x":2960,"y":3800} },
    scr_s8vl9g: { name: "Review Flow", route: "/", state: {"currentScreen":"review-flow"}, position: {"x":160,"y":7760} },
    scr_hbl8i8: { name: "Admin", route: "/", state: {"currentScreen":"admin"}, position: {"x":160,"y":9740} },
    scr_223tph: { name: "Partner Portal", route: "/partner", state: {"currentScreen":"partner"}, position: {"x":160,"y":11720} },
    scr_mr3km8: { name: "Brand Portal", route: "/brand", state: {"currentScreen":"brand"}, position: {"x":160,"y":13700} },
  },
  sections: {
    sec_j2knrk: { name: "Onboarding", x: 0, y: 1600, width: 1520, height: 1180 },
    sec_6ihvkd: { name: "Main Navigation", x: 0, y: 3580, width: 4320, height: 1180 },
    sec_w5ij42: { name: "Go Fish Feature", x: 0, y: 5560, width: 2920, height: 1180 },
    sec_kqsang: { name: "User Actions", x: 0, y: 7540, width: 1520, height: 1180 },
    sec_a6psi9: { name: "Admin", x: 0, y: 9520, width: 1520, height: 1180 },
    sec_dyi3q6: { name: "Partner Portal", x: 0, y: 11500, width: 1520, height: 1180 },
    sec_9rkv84: { name: "Brand Portal", x: 0, y: 13480, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_j2knrk", children: [
      { kind: "screen", id: "scr_gagljj" },
    ] },
    { kind: "section", id: "sec_6ihvkd", children: [
      { kind: "screen", id: "scr_hwd6an" },
      { kind: "screen", id: "scr_vduojr" },
      { kind: "screen", id: "scr_18pe2e" },
    ] },
    { kind: "section", id: "sec_w5ij42", children: [
      { kind: "screen", id: "scr_bkyfjr" },
      { kind: "screen", id: "scr_lic64i" },
    ] },
    { kind: "section", id: "sec_kqsang", children: [
      { kind: "screen", id: "scr_s8vl9g" },
    ] },
    { kind: "section", id: "sec_a6psi9", children: [
      { kind: "screen", id: "scr_hbl8i8" },
    ] },
    { kind: "section", id: "sec_dyi3q6", children: [
      { kind: "screen", id: "scr_223tph" },
    ] },
    { kind: "section", id: "sec_9rkv84", children: [
      { kind: "screen", id: "scr_mr3km8" },
    ] },
  ],
}
